/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

/**
 * A React functional component that manages genres.
 * It uses hooks such as useEffect, useRef, useState, useTranslation, and useDispatch.
 * It also imports the GenresManagementComponent from "./genresManagementComponent".
 * It uses the useWindowDimension hook from "../../components/hooks/useWindowDimension".
 * It dispatches the showToast action from "../../store/features/toast/toastSlice".
 * It imports the genres data from "../../api/genres.json".
 * It imports the debounce function from "lodash".
 */
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import "./genresManagementComponent";
import GenresManagementComponent from "./genresManagementComponent";

import useWindowDimension from "../../components/hooks/useWindowDimension";

import {
  createGenresResponce,
  deleteGenresResponce,
  genresListResponce,
  updateGenresResponce,
} from "../../store/features/genres/genresSlice";
import { getCloudinaryMediaBaseUrl } from "../../config/cloudinaryBase";
import { showToast } from "../../store/features/toast/toastSlice";

/**
 * A container component for managing genres.
 * @param {Object} props - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const GenresManagementContainer = (props) => {
  /**
   * This component defines multiple state variables and initializes them with their initial values.
   * It also initializes some refs and hooks for translation, table reference, dispatch, window dimensions,
   * page size, table container reference, loading state, modal name, search value, and various other values
   * related to genres and their creation and update.
   * @returns None
   */
  const { t } = useTranslation();
  const smarttableref = useRef();
  const genreList = useSelector((state) => state?.genres?.genresResponce);
  const dispatch = useDispatch();
  const dimensions = useWindowDimension();
  const pageSizeRef = useRef(15);
  const tableContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalName, setModalName] = useState({ modal: "add" });
  const [searchValue, setSearchValue] = useState(null);
  const [showCreateGenresModal, setShowCreateGenresModal] = useState(false);
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const [createValues, setCreateValues] = useState("");
  const [genrestitleValue, setGenrestitleValue] = useState("");
  const [genresdescriptionValue, setGenresdescriptionValue] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [updategenresValues, setUpdategenresValues] = useState(null);
  const [genresValue, setGenresValue] = useState("");
  const [genrestextcount, setGenrestextcount] = useState(
    modalName === "add" ? 0 : genresValue?.length
  );
  const [genrestitletextcount, setGenrestitletextcount] = useState(
    modalName === "add" ? 0 : genrestitleValue?.length
  );
  const [genresdescriptiontextcount, setGenresdescriptiontextcount] = useState(
    modalName === "add" ? 0 : genresdescriptionValue?.length
  );
  const [genreId, setGenreId] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [iscreateGenresModelLoaderButton, setIscreateGenresModelLoaderButton] =
    useState(false);
  const [isUpdateGenresModelLoaderButton, setIsUpdateGenresModelLoaderButton] =
    useState(false);
  const [filteredEventData, setFilteredEventData] = useState([]);
  const [updatetextcount, setUpdatetextcount] = useState(genresValue?.length);
  const genreCount = genreList?.length;

  /**
   * Sets up a state variable and an effect that updates the state variable after a delay.
   * @returns None
   */
  const [placeHolder, setPlaceHolder] = useState(true);
  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    if (Array.isArray(genreList)) {
      const lowercaseSearchValue = searchValue?.toLowerCase();

      const filteredData = genreList?.filter(
        (item) =>
          item?.titlestring?.toLowerCase()?.includes(lowercaseSearchValue) ||
          item?.title?.toLowerCase()?.includes(lowercaseSearchValue) ||
          item?.shortdesc?.toLowerCase()?.includes(lowercaseSearchValue)
      );

      setFilteredEventData(filteredData);
    }
  }, [searchValue, genreList]);

  /**
   * Retrieves a list of all genres from the server.
   * @returns None
   */
  const getList = async () => {
    dispatch(genresListResponce()).then((resultAction) => {
      if (genresListResponce.fulfilled.match(resultAction)) {
        setPlaceHolder(false);
      } else if (genresListResponce.rejected.match(resultAction)) {
        setPlaceHolder(false);
      }
    });
  };

  /**
   * Closes the delete user modal by setting the state variable `showDeleteUserModal` to false.
   * @returns None
   */
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);

  /**
   * Opens the delete user modal for the specified item.
   * @param {Event} e - The event object.
   * @param {Object} item - The item to be deleted.
   * @returns None
   */
  const openDeleteUserModal = (e, item) => {
    setGenreId(item?._id);
    setshowDeleteUserModal(true);
  };
  /**
   * Handles the change event of the table filter input.
   * @param {{string}} filterText - The text entered in the filter input.
   * @returns None
   */
  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  /**
   * Clears the search input by programmatically clicking the clear search button.
   * @returns None
   */
  const ClearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  /**
   * An array of column objects used for displaying data in a table.
   * Each column object contains a label, key, and additional properties.
   * @type {Array}
   * @property {string | JSX.Element} label - The label to display for the column.
   * @property {string} key - The key used to access the corresponding data in each row.
   * @property {boolean} filter - Indicates whether filtering is enabled for the column.
   * @property {boolean} sorting - Indicates whether sorting is enabled for the column.
   */
  const columns = [
    {
      label: (
        <>
          {t("GENERES")}{" "}
          <span className="thCount">
            {" "}
            {searchValue === null ? genreCount : filteredEventData?.length}
          </span>
        </>
      ),
      key: "title",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("TITLE_LABLE")}</>,
      key: "titlestring",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("DESCRIPTION_LABLE")}</>,
      key: "shortdesc",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("No_OF_EVENTS")}</>,
      key: "eventcount",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("ACTIONS")}</>,
      key: "status",
      filter: false,
      sorting: false,
    },
  ];

  /**
   * Deletes a user by sending a PUT request to the '/genre/deleteGenre' endpoint with the genre ID.
   * @returns None
   * @throws {Error} If there is an error during the deletion process.
   */
  const onDeleteUser = async () => {
    setDeleteLoader(true);
    dispatch(deleteGenresResponce(genreId)).then((resultAction) => {
      if (deleteGenresResponce.fulfilled.match(resultAction)) {
        dispatch(
          showToast({
            show: false,
            message: resultAction?.payload?.res?.message,
            type: "success",
          })
        );
        closeDeleteUserModal();
        setDeleteLoader(false);
      } else if (deleteGenresResponce.rejected.match(resultAction)) {
        closeDeleteUserModal();
        setDeleteLoader(false);
        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };

  const CLOUDINARY_URL = getCloudinaryMediaBaseUrl();

  /**
   * Opens the "Create Genres" modal and sets the necessary state variables.
   * @returns None
   */
  const openCreateGenresModal = () => {
    setModalName({ modal: "add" });
    setTimeout(() => {
      setShowCreateGenresModal(true);
    }, 1000);
  };

  /**
   * Sets the values of the form to the createValues state.
   * @param {{object}} form - The form object containing the values to set.
   * @returns None
   */
  const createGenresFunction = (form) => {
    setCreateValues(form);
  };

  /**
   * Closes the "Create Genres" modal by setting the state variables `showCreateGenresModal` to false
   * and `genrestextcount` to 0.
   * @returns None
   */
  const closeCreateGenresModal = () => {
    setShowCreateGenresModal(false);
    setGenrestextcount(0);
    setGenrestitletextcount(0);
    setGenresdescriptiontextcount(0);
  };

  /**
   * Loads more items when triggered. It sets the loading state to true, simulates a delay of 2 seconds,
   * and then sets the loading state to false and increases the page size by 2.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * of the container. If it is, and there are more items to load, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && genreList.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Represents a page title.
   * @type {Array<{title: string}>}
   */
  const pageTitle = [
    {
      title: "Events",
      path: "/events-list",
    },
  ];
  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * useEffect hook that sets the height of various elements based on their offsetHeight.
   * @param {{boolean}} loading - Indicates whether the page is currently loading.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("table-responsive")[0].offsetHeight
      );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
  }, [loading]);

  /**
   * Handles the submission of the create genre form data.
   * @param {{object}} data - The form data to be submitted.
   * @returns None
   */
  const handleSubmitCreate = async (data) => {
    setGenrestextcount(0);
    setGenrestitletextcount(0);
    setGenresdescriptiontextcount(0);
    if (modalName?.modal === "add") {
      setGenrestextcount(0);
      setIscreateGenresModelLoaderButton(true);
      const params = {
        gneresname: data?.gneresname,
        gneresdescription: data?.gneresdescription,
        gnerestitle: data?.gnerestitle,
      };

      dispatch(createGenresResponce(params)).then((resultAction) => {
        if (createGenresResponce.fulfilled.match(resultAction)) {
          getList();
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.message,
              type: "success",
            })
          );
          setShowCreateGenresModal(false);
          setIscreateGenresModelLoaderButton(false);
        } else if (createGenresResponce.rejected.match(resultAction)) {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.error?.message,
              type: "error",
            })
          );
          setShowCreateGenresModal(false);
          setIscreateGenresModelLoaderButton(false);
        }
      });
    } else {
      setUpdatetextcount(0);
      setIsUpdateGenresModelLoaderButton(true);
      const params = {
        id: genreId,
        gneresname: data?.gneresname,
        gneresdescription: data?.gneresdescription,
        gnerestitle: data?.gnerestitle,
      };
      dispatch(updateGenresResponce(params)).then((resultAction) => {
        if (updateGenresResponce.fulfilled.match(resultAction)) {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.message,
              type: "success",
            })
          );
          setShowCreateGenresModal(false);
          setIsUpdateGenresModelLoaderButton(false);
        } else if (updateGenresResponce.rejected.match(resultAction)) {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.error?.message,
              type: "error",
            })
          );
          setShowCreateGenresModal(false);
          setIsUpdateGenresModelLoaderButton(false);
        }
      });
    }
  };
  /**
   * Updates the genres values in the state with the provided form data.
   * @param {{object}} form - The form data containing the updated genres values.
   * @returns None
   */
  const updateGenresFunction = (form) => {
    setUpdategenresValues(form);
  };
  /**
   * Clears the update data by resetting the text count and resetting the values of the update genres form.
   * @returns None
   */
  const clearUpdateData = () => {
    setUpdatetextcount(0);
    updategenresValues.reset({
      Genresname: "",
    });
  };

  /**
   * Handles the change event of a text input field and updates the count of characters in the input.
   * @param {{Event}} e - The event object representing the change event.
   * @returns None
   */
  const handleupdatetextChange = (e) => {
    const value = e?.target?.value;
    setUpdatetextcount(value?.length);
  };

  /**
   * Executes a side effect when the dependencies change. In this case, it updates the value of a form field
   * with the provided genresValue.
   * @param {{Function}} updategenresValues - The function to update the genres values.
   * @param {{any}} genresValue - The value to update the genres field with.
   * @returns None
   */
  useEffect(() => {
    if (updategenresValues !== null) {
      updategenresValues.setValue("Gneresname", genresValue, {
        shouldValidate: true,
      });
    }
  }, [updategenresValues, genresValue]);

  /**
   * Handles the update of genres when a user selects an item.
   * @param {{Event}} e - The event object.
   * @param {{object}} item - The selected item.
   * @returns None
   */
  const onUpdateGenres = (e, item) => {
    setModalName({ modal: "Edit" });
    setGenresValue(item?.title);
    setGenrestitleValue(item?.titlestring);
    setGenrestextcount(item?.title?.length);
    setGenrestitletextcount(item?.titlestring?.length);
    setGenresdescriptiontextcount(item?.shortdesc?.length);
    setGenresdescriptionValue(item?.shortdesc);
    setGenreId(item?._id);
    setTimeout(() => {
      setShowCreateGenresModal(true);
    }, 1000);
  };

  /**
   * Handles the change event for the genres text input field.
   * @param {Event} e - The event object.
   * @returns None
   */
  const handleGenrestextChange = (e) => {
    const value = e.target.value;
    setGenrestextcount(value.length);
  };

  /**
   * Handles the change event for the "genrestitletext" input field.
   * @param {Event} e - The event object.
   * @returns None
   */
  const handleGenrestitletextChange = (e) => {
    const value = e.target.value;
    setGenrestitletextcount(value.length);
  };

  /**
   * Handles the change event for the genres description text input field.
   * @param {{Event}} e - The event object representing the change event.
   * @returns None
   */
  const handleGenresdescriptiontextChange = (e) => {
    const value = e.target.value;
    setGenresdescriptiontextcount(value.length);
  };

  return (
    <GenresManagementComponent
      createGenresFunction={createGenresFunction}
      clearUpdateData={clearUpdateData}
      modalName={modalName}
      pageTitle={pageTitle}
      createGenresModelLoaderButton={iscreateGenresModelLoaderButton}
      updateGenresModelLoaderButton={isUpdateGenresModelLoaderButton}
      showCreateGenresModal={showCreateGenresModal}
      openCreateGenresModal={openCreateGenresModal}
      BreadcrumbmainTitle={true}
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item);
      }}
      smarttableref={smarttableref}
      closeDeleteUserModal={() => {
        setshowDeleteUserModal(false);
      }}
      onDeleteUser={onDeleteUser}
      columns={columns}
      genresData={genreList}
      genrestextcount={genrestextcount}
      genrestitletextcount={genrestitletextcount}
      genresdescriptiontextcount={genresdescriptiontextcount}
      ClearSearchButton={ClearSearchButton}
      NoDataFound={t("NO_DATA_FOUND")}
      NoDataTitle={t("NO_DATA_FOUND")}
      NoDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_GENRE_NAMES_PLEASE_TRY_SEARCHING_AGAIN_OR_ADD_GENRE"
      )}
      noDataDescTwo={t("PLEASE_TRY_SEARCHING_AGAIN_OR_ADD_GENRE")}
      NoDataAddButtonTitle={t("ADD_GENERS")}
      onTableFilterChange={onTableFilterChange}
      loaderHtml={loaderHtml}
      closeCreateGenresModal={closeCreateGenresModal}
      EmptyDataAddButton={openCreateGenresModal}
      placeHolderShimer={placeHolder}
      itemsPerPage={pageSizeRef.current}
      searchFilterClear={searchFilterClear}
      dimensions={dimensions}
      tabHeaderHeight={tabHeaderHeight}
      breadcrumbHeight={breadcrumbHeight}
      searchValue={searchValue}
      updateGenresFunction={(form) => {
        updateGenresFunction(form);
      }}
      handleGenrestitletextChange={handleGenrestitletextChange}
      handleGenresdescriptiontextChange={handleGenresdescriptiontextChange}
      loading={loading}
      onUpdateGenres={(e, item) => onUpdateGenres(e, item)}
      handleSubmitCreate={handleSubmitCreate}
      genresValue={genresValue}
      genrestitleValue={genrestitleValue}
      genresdescriptionValue={genresdescriptionValue}
      tableContainerRef={tableContainerRef}
      handleGenrestextChange={handleGenrestextChange}
      emptyDataDesc={t(
        "STILL_NO_GENRE_HAS_BEEN_ADDED_PLEASE_CLICK_ON_THE_BELOW_BUTTON_TO_ADD_GENRE"
      )}
      emptyDataDescTow={t("PLEASE_CLICK_ON_THE_BELOW_BUTTON_TO_ADD_GENRE")}
      emptyTitle={t("NO_GENRE_ADDED_YET")}
      emptyImg={CLOUDINARY_URL + "v7vqwdvpm1sxnpfxov7g.png"}
      deleteLoader={deleteLoader}
    />
  );
};

export default GenresManagementContainer;
